module.exports = __webpack_public_path__ + "img/store_try.730ccd03.jpg";